<template>
  <div class="lead-segmented-control" role="group" :aria-label="label">
    <LeadButton
      v-for="option in options"
      :key="option.value"
      variant="white"
      class="segment"
      :class="{ 'is-selected': model === option.value }"
      :aria-pressed="model === option.value"
      :aria-label="option.label"
      :title="option.label"
      :icon-start="option.icon"
      :icon-size="16"
      @click="model = option.value">
      <span class="segment-label">{{ option.label }}</span>
    </LeadButton>
  </div>
</template>

<script setup lang="ts" generic="T extends string">
import type { Component } from 'vue';
import LeadButton from '@/components/generic/LeadButton.vue';

interface Props {
  label: string;
  options: { value: T; label: string; icon?: Component }[];
}

defineProps<Props>();
const model = defineModel<T>({ required: true });
</script>

<style scoped>
.lead-segmented-control {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border: 1px solid #eaecf0;
  border-radius: 7px;
  background: #f2f4f7;
}

.segment.lead-button {
  height: 24px;
  padding: 2px 9px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: #667085;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: none;
}

.segment.lead-button:hover {
  color: #344054;
  background: #eaecf0;
}

.segment.lead-button.is-selected {
  background: #fff;
  color: #344054;
  box-shadow: 0 1px 3px rgb(16 24 40 / 10%);
}

.segment.lead-button:focus-visible {
  outline: 2px solid var(--tblr-primary);
  outline-offset: 2px;
  z-index: 1;
}
</style>
